module.exports = __webpack_public_path__ + "static/media/clock.15d6d100.svg";